function Cancel({ fill = "#B0BAC9", height = 12, width = 12 }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.17496 5.00065L9.90355 1.26163C10.0061 1.1587 10.0627 1.02138 10.0629 0.87496C10.0629 0.728456 10.0063 0.590977 9.90355 0.488212L9.57681 0.160651C9.47408 0.0574806 9.33714 0.000976562 9.19096 0.000976562C9.04502 0.000976562 8.90808 0.0574806 8.80535 0.160651L5.07676 3.89943L1.34801 0.160651C1.24544 0.0574806 1.10842 0.000976562 0.962321 0.000976562C0.816381 0.000976562 0.67936 0.0574806 0.576797 0.160651L0.249893 0.488212C0.0371452 0.701546 0.0371452 1.04854 0.249893 1.26163L3.97857 5.00065L0.249893 8.73952C0.147248 8.8426 0.0907374 8.97992 0.0907374 9.12634C0.0907374 9.27277 0.147248 9.41008 0.249893 9.51309L0.576716 9.84065C0.679279 9.94374 0.816381 10.0003 0.96224 10.0003C1.10834 10.0003 1.24536 9.94374 1.34793 9.84065L5.07668 6.10179L8.80527 9.84065C8.908 9.94374 9.04494 10.0003 9.19088 10.0003H9.19104C9.33706 10.0003 9.474 9.94374 9.57673 9.84065L9.90347 9.51309C10.006 9.41017 10.0626 9.27277 10.0626 9.12634C10.0626 8.97992 10.006 8.8426 9.90347 8.7396L6.17496 5.00065Z"
        fill={fill}
      />
    </svg>
  );
}

export default Cancel;
